var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
    icon: true,
    'icon-small': _vm.size === 'small',
    'icon-medium': _vm.size === 'medium',
    'icon-large': _vm.size === 'large',
    'icon-enormous': _vm.size === 'enormous',
    'icon-levitate': _vm.levitate
  },style:({ background: _vm.background })},[(_vm.type === 'icon')?_c('span',{staticClass:"icon-container"},[_vm._t("default")],2):_vm._e(),(_vm.type === 'button')?_c('button',{staticClass:"icon-button",on:{"click":_vm.handleClick}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }